import { isDeductionDashboardOwner } from '../../../utils/other-deductions';

export const deductionDepartmentRoutes = [
  { key: 'fgi', label: 'FGI', path: '/deductions/fgi', matchers: ['fgi'] },
  { key: 'procurement', label: 'Procurement', path: '/deductions/procurement', matchers: ['procurement'] },
  { key: 'insurance', label: 'Insurance', path: '/deductions/insurance', matchers: ['insurance'] }
];

export const getAccessibleDeductionDepartments = (user) => {
  if (isDeductionDashboardOwner(user)) {
    return deductionDepartmentRoutes;
  }

  const normalizedAccess = [...new Set(
    (Array.isArray(user?.deductionAccess) ? user.deductionAccess : [])
      .map((value) => String(value || '').trim().toLowerCase())
      .filter(Boolean)
  )];

  return deductionDepartmentRoutes.filter((department) => normalizedAccess.includes(department.key));
};

export const getDefaultDeductionPath = (user) =>
  getAccessibleDeductionDepartments(user)[0]?.path || '/';
